import { type FC, type FormEventHandler } from 'react';
import { Fieldset, Flex, NumberInput, Paper, Select, Stack, TextInput } from '@mantine/core';
import { TimePicker } from '@mantine/dates';
import { type UseFormReturnType } from '@mantine/form';
import { currencies } from '~/entities/currency';
import { requisiteTypes } from '~/entities/requisiteType';
import { type CascadeEditorFormValues } from '../lib';

interface CascadeInfoCardProps {
    form: UseFormReturnType<CascadeEditorFormValues>;
    onSubmit: FormEventHandler<HTMLFormElement>;
}

export const CascadeInfoCard: FC<CascadeInfoCardProps> = ({ form, onSubmit }) => {
    return (
        <Paper
            p='md'
            radius='md'
            withBorder
        >
            <form
                id='cascade-info-form'
                onSubmit={onSubmit}
            >
                <Stack gap='md'>
                    <TextInput
                        label='Название'
                        placeholder='Введите название'
                        {...form.getInputProps('name')}
                    />

                    <Fieldset legend='Фильтр'>
                        <Stack gap='md'>
                            <Flex
                                gap='md'
                                wrap='wrap'
                            >
                                <NumberInput
                                    min={0}
                                    flex={1}
                                    miw={200}
                                    label='Мин. сумма'
                                    placeholder='Введите число'
                                    {...form.getInputProps('minAmount')}
                                />

                                <NumberInput
                                    min={0}
                                    flex={1}
                                    miw={200}
                                    label='Макс. сумма'
                                    placeholder='Введите число'
                                    {...form.getInputProps('maxAmount')}
                                />
                            </Flex>

                            <Select
                                label='Валюта'
                                data={currencies}
                                searchable
                                placeholder='Выберите валюту'
                                {...form.getInputProps('currency')}
                            />

                            <Select
                                label='Тип реквизита'
                                data={requisiteTypes}
                                searchable
                                placeholder='Выберите тип'
                                {...form.getInputProps('requisiteType')}
                            />

                            <Flex
                                gap='md'
                                wrap='wrap'
                            >
                                <TimePicker
                                    flex={1}
                                    miw={200}
                                    label='Время начала'
                                    {...form.getInputProps('startAt')}
                                />

                                <TimePicker
                                    flex={1}
                                    miw={200}
                                    label='Время окончания'
                                    {...form.getInputProps('endAt')}
                                />
                            </Flex>
                        </Stack>
                    </Fieldset>
                </Stack>
            </form>
        </Paper>
    );
};
